import React from 'react';
import styled from '@emotion/styled';
import { t } from 'services/translation';
import { string, func } from 'prop-types';

import SearchIcon from 'views/ui/icons/search-icon-modern';
import CloseIcon from 'views/ui/icons/close-icon';
import { Theme } from 'ui_system/theme';

const TextInput = styled.input`
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 40px;
  box-sizing: border-box !important;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: white;

  appearance: none !important;

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${Theme.colors.inputs.placeholder};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${Theme.colors.inputs.placeholder};
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 250px;
  height: 44px;
  @media screen and (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    max-width: 100%;
  }
`;

const Search = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'initial')};

  svg {
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15px;
    color: ${Theme.colors.line};
    fill: ${Theme.colors.line};
    font-size: 16px;
  }
`;

export function SearchFilter({
  applyFilter,
  clearFilter,
  query,
  updateQuery,
  placeholder,
}) {
  const apply = ({ target }) => {
    target.blur();
    applyFilter();
  };

  return (
    <Container>
      <Search>
        <TextInput
          type="search"
          placeholder={t(placeholder)}
          value={query}
          onChange={({ target }) => updateQuery(target.value)}
          onKeyPress={(e) => (e.key === 'Enter' ? apply(e) : null)}
          data-testid="search-input"
        />
        {query && query.length > 0 ? (
          <IconWrapper onClick={clearFilter} data-testid="clear-search-icon">
            <CloseIcon />
          </IconWrapper>
        ) : (
          <IconWrapper>
            <SearchIcon />
          </IconWrapper>
        )}
      </Search>
    </Container>
  );
}

SearchFilter.propTypes = {
  applyFilter: func,
  clearFilter: func.isRequired,
  query: string.isRequired,
  placeholder: string,
  updateQuery: func.isRequired,
};

SearchFilter.defaultProps = {
  applyFilter: () => {},
  placeholder: 'Search',
};
